/**
 * Generates all possible permutations of the input array of digits
 *
 * @param arr - Array of string digits to permute
 * @returns string[] - Array of all possible digit permutations
 */
export const generatePermutations = (arr: string[]): string[] => {
  if (arr.length === 1) {
    return [arr[0]]
  }
  const result: string[] = []
  for (let i = 0; i < arr.length; i++) {
    const rest = [...arr.slice(0, i), ...arr.slice(i + 1)]
    const permutations = generatePermutations(rest)
    for (let j = 0; j < permutations.length; j++) {
      result.push(arr[i] + permutations[j])
    }
  }
  return result
}

/**
 * Generates all two-digit numbers (00-99) that include the specified digit
 *
 * @param digit - The digit to include in the generated numbers
 * @returns string[] - Array of two-digit strings containing the specified digit
 */
export const generateNineteenNumber = (digit: string): string[] => {
  const result: string[] = []
  for (let i = 0; i < 100; i++) {
    const str = i.toString().padStart(2, '0')
    if (str.includes(digit)) {
      result.push(str)
    }
  }

  return result
}

/**
 * Generates numbers by combining the given digit with each digit 0-9
 *
 * @param digit - The digit to use in number generation
 * @param fromBack - If true, places the digit at the end (x0-x9), otherwise at the start (0x-9x)
 * @returns string[] - Array of generated two-digit strings
 */
export const generateSwitchNumber = (
  digit: string,
  fromBack = false,
): string[] => {
  const result = []
  for (let i = 0; i < 10; i++) {
    if (fromBack) {
      result.push(`${i}${digit}`)
    } else {
      result.push(`${digit}${i}`)
    }
  }
  return result
}
